// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { InstrumentTypesColor, getInstrumentTypeShortName } from '@shared/utils/Instruments/InstrumentTypes';
import { DataCache } from '../DataCache';
class AccountUtilsClass {
    getAccountsList() {
        const accountList = new Array();
        const accounts = DataCache.getAccounts();
        for (const accId in accounts) {
            accountList.push(accounts[accId]);
        }
        return accountList;
    }
    getSortedAccountList() {
        const accounts = this.getAccountsList();
        return accounts.sort((a, b) => {
            return String.CompareOrdinal(a.FullAccString, b.FullAccString);
        });
    }
    getInsTypeShortName(account) {
        return getInstrumentTypeShortName(account.PreferredInstrumentType);
    }
    getInstrumentColor(account) {
        return InstrumentTypesColor[account.PreferredInstrumentType];
    }
    needAddType(account) {
        return account.PreferredInstrumentType !== -1;
    }
}
export const AccountUtils = new AccountUtilsClass();
